import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class NodeSizeParams extends ConfigNode
  @className = 'NodeSizeParams'

  constructor: ->
    super('nodeSizeParams')

  @load: ->
    super('nodeSizeParams', @)

  update: (key, params = {}) ->
    @set('value', key)
    @save(params)

  key: ->
    @get('value')

  reset: (params = {}) ->
    @update(undefined, params)

export default NodeSizeParams
